var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 11.79H29.4691V40.9998H12.5312V11.79Z",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7383 5.75684H26.2622V11.7903H15.7383V5.75684Z",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0059 5.75676V1",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 17.6279H19.4192",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 17.6279H24.8724",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 22.0039H19.4192",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 22.0039H24.8724",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 26.3999H19.4192",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 26.3999H24.8724",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 30.7964H19.4192",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 30.7964H24.8724",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 35.1826H19.4192",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 35.1826H24.8724",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 21.5303H40.9999V41H29.4688V21.5303Z",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5303H12.5312V41H1V21.5303Z",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7666 27.4194V25.3911",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7666 31.7958V29.7778",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7666 36.1914V34.1631",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2354 27.4194V25.3911",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2354 31.7958V29.7778",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2354 36.1914V34.1631",
    stroke: "#C32126",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.ec513b33176f7b2c0704781d9fc60d54.svg";
export { ForwardRef as ReactComponent };